import React from 'react';

export const CloseCircle = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="16" cy="16" r="15.5" stroke={props.color} fillOpacity="0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.44 10.56C21.7 10.82 21.715 11.23 21.486 11.508L21.44 11.558L16.998 16L21.44 20.442C21.716 20.718 21.716 21.165 21.44 21.44C21.18 21.7 20.77 21.715 20.492 21.486L20.442 21.44L16 16.998L11.558 21.44C11.282 21.716 10.835 21.716 10.56 21.44C10.3 21.18 10.285 20.77 10.514 20.492L10.56 20.442L15 16L10.56 11.558C10.284 11.282 10.284 10.835 10.56 10.56C10.82 10.3 11.23 10.285 11.508 10.514L11.558 10.56L16 15L20.442 10.56C20.718 10.284 21.165 10.284 21.44 10.56Z"
      fill={props.color}
      strokeWidth={props.strokeWidth || '0'}
      className="fill-current"
    />
  </svg>
);
